import {
  CALL_OUTCOME_LABELS,
  CALL_STATUS_LABELS,
  type CallOutcome,
  type CallStatus,
} from "@shared/modules/x-appels";
import { Badge } from "../../../core/components/ui/badge";

type Variant = "neutral" | "primary" | "success" | "warning" | "danger" | "live" | "info";

const OUTCOME_VARIANT: Record<CallOutcome, Variant> = {
  rdv_pris: "success",
  message: "warning",
  rappel: "warning",
  renseignement: "info",
  transfert: "primary",
  aucun: "neutral",
};

/** Un appel se lit d'abord par ce qu'il a produit ; le statut ne s'affiche que s'il dit autre chose. */
export function CallBadge({ status, outcome }: { status: CallStatus; outcome: CallOutcome }) {
  if (status === "en_cours") return <Badge variant="live">En direct</Badge>;
  if (status === "manque") return <Badge variant="danger">{CALL_STATUS_LABELS.manque}</Badge>;
  return <Badge variant={OUTCOME_VARIANT[outcome]}>{CALL_OUTCOME_LABELS[outcome]}</Badge>;
}
